/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { RoomRecursiveParentFragmentDoc } from "../../rooms/graphql/fragments.recursive.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProductPositionRecursiveParentFragment = {
  __typename: "ProductPosition"
  parent?:
    | { __typename: "Project"; id: string; title: string }
    | {
        __typename: "Room"
        id: string
        label?: string | null
        number: string
        parent?:
          | {
              __typename: "Floor"
              id: string
              label?: string | null
              parent?: {
                __typename: "Project"
                id: string
                title: string
              } | null
            }
          | { __typename: "Project"; id: string; title: string }
          | null
      }
    | null
}

export const ProductPositionRecursiveParentFragmentDoc = gql`
  fragment ProductPositionRecursiveParent on ProductPosition {
    parent {
      ... on Project {
        id
        title
      }
      ... on Room {
        id
        label
        number
        ...RoomRecursiveParent
      }
    }
  }
  ${RoomRecursiveParentFragmentDoc}
`
